export const contactContent = {
  nl: {
    seoTitle: 'Contact · Perpetual Plexus',
    seoDescription:
      'Neem contact op met Rot8ion (Rob van Rooij) over Perpetual Plexus lichtsculpturen: info [at] rot8ion.com, Valkenswaard, Nederland.',
    title: 'Contact',
    emailLabel: 'E-mail',
    residenceLabel: 'Residentie',
    residence: ['Valkenswaard', 'Nederland'],
    socialLabel: 'Social media',
    newsletterTitle: 'Nieuwsbrief',
    newsletterIntro: 'Blijf op de hoogte van nieuw werk, tentoonstellingen en projecten.',
    newsletterBody: [
      'Af en toe stuur ik een update over wat er speelt rond Perpetual Plexus: nieuwe lichtsculpturen, samenwerkingen, tentoonstellingen of een kijkje achter de schermen.',
      'Je kunt je op elk moment weer uitschrijven via de link onderaan elke e-mail.',
    ],
  },
  en: {
    seoTitle: 'Contact · Perpetual Plexus',
    seoDescription:
      'Get in touch with Rot8ion (Rob van Rooij) about Perpetual Plexus light sculptures: info [at] rot8ion.com, Valkenswaard, the Netherlands.',
    title: 'Contact',
    emailLabel: 'Email',
    residenceLabel: 'Based in',
    residence: ['Valkenswaard', 'The Netherlands'],
    socialLabel: 'Social media',
    newsletterTitle: 'Newsletter',
    newsletterIntro: 'Stay up to date on new work, exhibitions, and projects.',
    newsletterBody: [
      'Every now and then I send an update on what is happening around Perpetual Plexus: new light sculptures, collaborations, exhibitions, or a behind-the-scenes look.',
      'You can unsubscribe at any time using the link at the bottom of every email.',
    ],
  },
} as const;
